import RateAPI from "../api/rate";
import i18n from "../main";
import Vue from 'vue'
//import i18n from 'vue-i18n';

export const rates = {
    state: {
        rates: [],
        rateOptions:{
            lineCount:0,
            showDeleted:false,
            orderBy:'name',
            orderDirection:'asc',
            itemsPerPage:10,
            itemAdded:false,
            itemSearched:false,
            selectedYear:0
        },
        ratesLoadStatus: 0,
        ratesCopyStatus:0,
        rateAddStatus: 0,
        rateAddText: "",

        rateEdit: {
            id: 0,
            lp: 0,
            name: '',
            category:1,
            free: '',
            tolerance:0,
            mealsFromJournal:true,
            year_id:0,
            monthly:0,
            monthlyNP:0,
            monthlyMeal:0,
            monthlyOther:0,
            hour:0,
            overtime:0,
            hasBreakfast:true,
            breakfast:0,
            hasLunch:true,
            lunch:0,
            hasTea:true,
            tea:0,
            other:0,
            hourNP:0,
            breakfastNP:0,
            lunchNP:0,
            teaNP:0,
            otherNP:0
        },
        rateEditDefault: {
            id: 0,
            lp: 0,
            name: '',
            category:1,
            free: '',
            tolerance:0,
            mealsFromJournal:true,
            year_id:0,
            monthly:0,
            monthlyNP:0,
            monthlyMeal:0,
            monthlyOther:0,
            hour:0,
            overtime:0,
            hasBreakfast:true,
            breakfast:0,
            hasLunch:true,
            lunch:0,
            hasTea:true,
            tea:0,
            other:0,
            hourNP:0,
            breakfastNP:0,
            lunchNP:0,
            teaNP:0,
            otherNP:0
            
        },
        rateEditLoadStatus: 0,
        rateEditStatus: 0,
        rateEditText: "",

        rateDeleteStatus: 0,
        rateDeleteText: "",

    },

    actions: {
        loadRates({ state, commit, dispatch }) {
            commit("setRatesLoadStatus", 1);
                RateAPI.getRates({
                    offset:0,
                    itemsPerPage:state.rateOptions.itemsPerPage, 
                    orderBy:state.rateOptions.orderBy,
                    orderDirection:state.rateOptions.orderDirection,
                    showDeleted:state.rateOptions.showDeleted,
                    selectedYear:state.rateOptions.selectedYear
                })
                .then(function(response) {
                    commit("setOptionsItemAddedAndSearchedFalse");
                    commit("setRateLineCount", response.data.lineCount);
                    commit("setRates", response.data.rates);
                    dispatch("applyIndexOnRates");
                    commit("setRatesLoadStatus", 2);
                })
                .catch(function() {
                    commit("setRates", []);
                    commit("setRatesLoadStatus", 3);
                });
         
        },
        loadMoreRates({ state, commit, dispatch }) {
            commit("setRatesLoadStatus", 1);
                RateAPI.getRates({
                    offset:state.rates.length,
                    itemsPerPage:state.rateOptions.itemsPerPage, 
                    orderBy:state.rateOptions.orderBy,
                    orderDirection:state.rateOptions.orderDirection,
                    showDeleted:state.rateOptions.showDeleted,
                    selectedYear:state.rateOptions.selectedYear
                })
                .then(function(response) {
                    commit("setRateLineCount", response.data.lineCount);
                    commit("setRates", Vue._.concat(state.rates, response.data.rates));
                    dispatch("applyIndexOnRates");
                    commit("setRatesLoadStatus", 2);
                })
                .catch(function() {
                    commit("setRates", []);
                    commit("setRatesLoadStatus", 3);
                });
         
        },
        searchRates({ state, commit, dispatch },data) {
            commit("setRatesLoadStatus", 1);
                RateAPI.searchRates({
                    showDeleted:state.rateOptions.showDeleted,
                    selectedYear:state.rateOptions.selectedYear,
                    filterableHeaders:data.filterableHeaders,
                    q:data.q
                })
                .then(function(response) {
                    commit("setOptionsItemAddedAndSearchedFalse");
                    commit("setRateSearchedTrue");
                    commit("setRateLineCount", response.data.lineCount);
                    commit("setRates", response.data.rates);
                    dispatch("applyIndexOnRates");
                    commit("setRatesLoadStatus", 2);
                })
                .catch(function() {
                    commit("setRates", []);
                    commit("setRatesLoadStatus", 3);
                });
         
        },
        copyRates({ commit, state, dispatch }, data) {
            commit("setRatesCopyStatus", 1);

            RateAPI.postCopyRates(
                data.source,
                data.destination
            )
                .then(function(response) {
                    commit("setRatesCopyStatus", 2);
                    dispatch("loadRates");
                })
                .catch(function(error) {
                    commit("setRatesCopyStatus", 3);
                });
        },
        setRateOptions({ state, commit, dispatch },data){
            commit("setRateOptions",data.options);
            dispatch("loadRates");
        },
        applyIndexOnRates({ commit, state, dispatch }) {
            let localRates = state.rates;

            var i = 1;
            localRates.forEach(rate => {
                rate.lp = i;
                i++;
            });

            commit("setRates",localRates);
        },
        addRate({ commit, state, dispatch }, data) {
            commit("setRateAddStatus", 1);
            commit("setRateAddText", "");

            RateAPI.postAddNewRate(
                data.name,
                data.category,
                data.free,
                data.tolerance,
                data.mealsFromJournal,
                data.hasBreakfast,
                data.hasLunch,
                data.hasTea,
                data.year_id,
                data.monthly,
                data.monthlyNP,
                data.monthlyMeal,
                data.monthlyOther,
                data.hour,
                data.overtime,
                data.breakfast,
                data.lunch,
                data.tea,
                data.other,
                data.hourNP,
                data.breakfastNP,
                data.lunchNP,
                data.teaNP,
                data.otherNP
            )
                .then(function(response) {
                    commit("setRateAddStatus", 2);
                    commit("setAddedRate",response.data);
                    commit("setRateLineCount", state.rateOptions.lineCount + 1);
                    dispatch("applyIndexOnRates");
                    dispatch("loadMenuDictionariesCount");
                    //dispatch("loadRateLookup",{year_id:response.data.year_id});
                })
                .catch(function(error) {
                    commit("setRateAddStatus", 3);
                    commit("setRateAddText", error.response.data.errors);
                });
        },

        loadRateEdit({ commit }, data) {
            commit("setRateEditLoadStatus", 1);
            commit("setRateEditStatus", 0);
            commit("setRateEditText", "");

            RateAPI.getRateEdit(data.slug)
                .then(function(response) {
                    commit("setRateEdit", response.data);
                    commit("setRateEditLoadStatus", 2);
                })
                .catch(function() {
                    commit("setRateEdit", {});
                    commit("setRateEditLoadStatus", 3);
                });
        },
        loadRateEditDefault({ commit }) {
            commit("setRateEditDefault");
        },
        loadRateAddDefault({ commit }) {
            commit("setRateAddStatus", 0);
            commit("setRateAddText", "");
        },
        editRate({ commit, state, dispatch }, data) {
            commit("setRateEditStatus", 1);

            RateAPI.putEditRate(
                data.slug,
                data.name,
                data.category,
                data.free,
                data.tolerance,
                data.mealsFromJournal,
                data.hasBreakfast,
                data.hasLunch,
                data.hasTea,
                data.year_id,
                data.monthly,
                data.monthlyNP,
                data.monthlyMeal,
                data.monthlyOther,
                data.hour,
                data.overtime,
                data.breakfast,
                data.lunch,
                data.tea,
                data.other,
                data.hourNP,
                data.breakfastNP,
                data.lunchNP,
                data.teaNP,
                data.otherNP
            )
                .then(function(response) {
           
                    commit("setRateEditStatus", 2);
                    commit("setEditedRate",response.data)
                    dispatch("applyIndexOnRates");
                    //dispatch("loadRateLookup",{year_id:response.data.year_id});
                })
                .catch(function(error) {
                    commit("setRateEditStatus", 3);
                    commit("setRateEditText", error.response.data.errors);
                });
        },
        editRateReactivate({ commit, state, dispatch }, data) {
            commit("setRateEditStatus", 1);
  
            RateAPI.putReactivateRate(data.slug)
                .then(function(response) {
                    commit("setRateEditStatus", 2);
                    commit("setEditedRate",response.data)
                    dispatch("applyIndexOnRates");
                    dispatch("loadMenuDictionariesCount");
                    //dispatch("loadRateLookup",{year_id:response.data.year_id});
                })
                .catch(function(error) {
                    commit("setRateEditStatus", 3);
                });
        },
        deleteRate({ commit, state, dispatch }, data) {
            commit("setRateDeleteStatus", 1);

            RateAPI.deleteRate(data.slug)
                .then(function(response) {
                    commit("setRateDeleteStatus", 2);
                    if(state.rateOptions.showDeleted){
                        commit("setEditedRate",response.data)
                    }else{
                        commit("setRateLineCount", state.rateOptions.lineCount - 1);
                        commit("setDeletedRate",response.data)
                    }
                    dispatch("loadMenuDictionariesCount");
                    //dispatch("loadRateLookup",{year_id:response.data.year_id});
                    dispatch("applyIndexOnRates");
                })
                .catch(function() {
                    commit("setRateDeleteStatus", 3);
                });
        },
        forceDeleteRate({ commit, state, dispatch }, data) {
            commit("setRateDeleteStatus", 1);

            RateAPI.forceDeleteRate(data.slug)
                .then(function(response) {
                    commit("setRateDeleteStatus", 2);
                    commit("setRateLineCount", state.rateOptions.lineCount - 1);
                    commit("setDeletedRate",response.data)
                    dispatch("applyIndexOnRates");
                })
                .catch(function() {
                    commit("setRateDeleteStatus", 3);
                });
        },
    },
    mutations: {
        setRateOptions(state,options){
            state.rateOptions = options;
            state.rateEdit.year_id = options.selectedYear;
            state.rateEditDefault.year_id = options.selectedYear;
        },
        setRatesLoadStatus(state, status) {
            state.ratesLoadStatus = status;
        },
        setRatesCopyStatus(state, status) {
            state.ratesCopyStatus = status;
        },
        setRates(state, rates) {
            state.rates = rates;
        },
        setRateLineCount(state, lineCount) {
            state.rateOptions.lineCount = lineCount;
        },
        setRateAddStatus(state, status) {
            state.rateAddStatus = status;
        },
        setRateAddText(state, text) {
            state.rateAddText = text;
        },
        setRateEdit(state, rate) {
            //pobiera dane do edycji
            state.rateEdit = rate;
            //zmiana formatu
            state.rateEdit.monthly = i18n.n(state.rateEdit.monthly, 'number', 'pl-PL')
            state.rateEdit.monthlyNP = i18n.n(state.rateEdit.monthlyNP, 'number', 'pl-PL')
            state.rateEdit.monthlyMeal = i18n.n(state.rateEdit.monthlyMeal, 'number', 'pl-PL')
            state.rateEdit.monthlyOther = i18n.n(state.rateEdit.monthlyOther, 'number', 'pl-PL')
            state.rateEdit.hour = i18n.n(state.rateEdit.hour, 'number', 'pl-PL')
            state.rateEdit.overtime = i18n.n(state.rateEdit.overtime, 'number', 'pl-PL')
            state.rateEdit.breakfast = i18n.n(state.rateEdit.breakfast, 'number', 'pl-PL')
            state.rateEdit.lunch = i18n.n(state.rateEdit.lunch, 'number', 'pl-PL')
            state.rateEdit.tea = i18n.n(state.rateEdit.tea, 'number', 'pl-PL')
            state.rateEdit.other = i18n.n(state.rateEdit.other, 'number', 'pl-PL')
            state.rateEdit.hourNP = i18n.n(state.rateEdit.hourNP, 'number', 'pl-PL')
            state.rateEdit.breakfastNP = i18n.n(state.rateEdit.breakfastNP, 'number', 'pl-PL')
            state.rateEdit.lunchNP = i18n.n(state.rateEdit.lunchNP, 'number', 'pl-PL')
            state.rateEdit.teaNP = i18n.n(state.rateEdit.teaNP, 'number', 'pl-PL')
            state.rateEdit.otherNP = i18n.n(state.rateEdit.otherNP, 'number', 'pl-PL')

        },
        setEditedRate(state, rate) {
            var lp = Vue._.find(state.rates,{'id':rate.id}).lp;
            var index = Vue._.findIndex(state.rates,{'id':rate.id});
           
            state.rates[index] = rate;
            state.rates[index].lp = lp;
        },
        setAddedRate(state, rate) {
           
            state.rateOptions.itemAdded = true;
            state.rates.push(rate);
        },
        setRateSearchedTrue(state) {
            state.rateOptions.itemSearched = true;
        },
        setOptionsItemAddedAndSearchedFalse(state) {
            state.rateOptions.itemAdded = false;
            state.rateOptions.itemSearched = false;
        },
        setDeletedRate(state, rate) {
            var index = Vue._.findIndex(state.rates,{'id':rate.id});
            state.rates.splice(index,1);
        },
        setRateEditDefault(state) {
            state.rateEdit = { ...state.rateEditDefault };
        },
        setRateEditStatus(state, status) {
            state.rateEditStatus = status;
        },
        setRateEditText(state, text) {
            state.rateEditText = text;
        },
        setRateEditLoadStatus(state, status) {
            state.rateEditLoadStatus = status;
        },
        setRateDeleteStatus(state, status) {
            state.rateDeleteStatus = status;
        },
        setRateDeletedText(state, text) {
            state.rateDeleteText = text;
        }
    },

    getters: {
        getRateOptions(state){
            return state.rateOptions;
        },
        getRatesLoadStatus(state) {
            return state.ratesLoadStatus;
        },
        getRatesCopyStatus(state) {
            return function(){
                return state.ratesCopyStatus;
            }
        },
        getRates(state) {
            return state.rates;
        },
        getRateAddStatus(state) {
            return function(){
                return state.rateAddStatus;
            } 
        },
        getRateAddText(state) {
            return state.rateAddText;
        },
        getRateEdit(state) {
            return state.rateEdit;
        },
        getRateEditStatus(state) {
          return function(){
            return state.rateEditStatus;
          }
        },
        getRateEditing(state) {
            return state.rateEdit.id > 0;
        },
        getRateEditText(state) {
            return state.rateEditText;
        },
        getRateEditLoadStatus(state) {
            return state.rateEditLoadStatus;
            
        },
        getRateDeleteStatus(state) {
            return function(){
                return state.rateDeleteStatus;
            }
        },
        getRateDeleteText(state) {
            return state.rateDeleteText;
        }
    }
};
